import { InjectionToken } from '@angular/core';
import {
    IDatiqLogOtelConfig,
    IDatiqLogOtelConfigExporter,
    IDatiqLogOtelConfigProcessor,
} from './datiq-log-otel.interface';

import {
    DatiqLogOtelExporters,
    DatiqLogOtelProcessors,
} from './datiq-log-otel.enum';
import { DATIQ_DEFAULT_ARRAY } from './datiq-app-default-values';
export const DATIQ_LOG_OTEL_SERVICE_NAME = 'datiq-log-otel-service-name';

export const DATIQ_LOG_OTEL_CONFIG = new InjectionToken<IDatiqLogOtelConfig>(
    'DatiqLogOtelConfig'
);

export const emptyDatiqLogOtelConfigExporter: IDatiqLogOtelConfigExporter = {
    type: DatiqLogOtelExporters.Unknown,
    processor: DatiqLogOtelProcessors.Batch,
};

export const emptyDatiqLogOtelConfig: IDatiqLogOtelConfig = {
    serviceName: DATIQ_LOG_OTEL_SERVICE_NAME,
    serviceVersion: '0.0.1',
    exporters: DATIQ_DEFAULT_ARRAY as IDatiqLogOtelConfigExporter[],
    processors: DATIQ_DEFAULT_ARRAY as IDatiqLogOtelConfigProcessor[],
};

export const getDatiqLogOtelBrowser = (userAgent: string): string => {
    const browser = userAgent.toLowerCase();
    const browsers = {
        chrome: /chrome/.test(browser),
        safari: /safari/.test(browser),
        firefox: /firefox/.test(browser),
        ie: /internet explorer/.test(browser),
    };

    const browserName = Object.keys(browsers).find((key) => browsers[key]);

    return browserName ?? 'unknown';
};
export const getDatiqLogOtelBrowserVersion = (userAgent: string): string => {
    const browser = userAgent.toLowerCase();
    const browserName: string = getDatiqLogOtelBrowser(userAgent);

    return browser.split(`${browserName}/`)[1]?.split(' ')?.[0] ?? 'unknown';
};
